import { render } from "./ReporteAuditoria.vue?vue&type=template&id=23c68698"
import script from "./ReporteAuditoria.vue?vue&type=script&lang=js"
export * from "./ReporteAuditoria.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__